import apiService from './apiService';
import { Get_Token } from 'resolvers/Get_Token';

export const getEntities = async () => {
    const response = await apiService.get('/businesses/entities', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const getIndustries = async () => {
    const response = await apiService.get('/businesses/industries', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const createBusiness = async data => {
    const response = await apiService.post('/businesses', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const postKYB = async data => {
    const response = await apiService.post('/businesses/kyb', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const getBusiness = async () => {
    const response = await apiService.get('/businesses', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const updateBusiness = async data => {
    const response = await apiService.patch(`/businesses`, data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const postNotOwner = async data => {
    const response = await apiService.post('/businesses/owners', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const postOwner = async data => {
    const response = await apiService.post('/businesses/owners/me', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const postBankLink = async data => {
    const response = await apiService.post('/banks/auth', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const createSession = async data => {
    const response = await apiService.post(
        '/banks/session',
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
};

export const verifyRoutingNumber = async data => {
    const response = await apiService.post('banks/routing/verify', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const updateFundingType = async data => {
    const response = await apiService.patch(`/businesses/funding-type`, data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const postBankPrefundAccount = async data => {
    const response = await apiService.post(`/banks/prefunding-account`, data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const patchTransactionProjections = async (idBusiness, data, transactionType) => {
    const response = await apiService.patch(`/businesses/${idBusiness}/projections/${transactionType}`, data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const generateOwnershipDisclosure = async idBusiness => {
    const response = await apiService.post(
        `/businesses/${idBusiness}/generate-ownership-disclosure`,
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
};

export const retrieveOwnershipDisclosure = async idBusiness => {
    const response = await apiService.get(`/businesses/${idBusiness}/retrieve-ownership-disclosure`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};
